import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { dbToGain } from "../../core/type/Conversions";
import { optionsFromArguments } from "../../core/util/Defaults";
import { MeterBase } from "./MeterBase";
import { assert } from "../../core/util/Debug";
/**
 * Get the current frequency data of the connected audio source using a fast Fourier transform.
 * @category Component
 */
export var FFT = /*#__PURE__*/function (_MeterBase) {
  _inherits(FFT, _MeterBase);
  function FFT() {
    var _this;
    _classCallCheck(this, FFT);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FFT).call(this, optionsFromArguments(FFT.getDefaults(), arguments, ["size"])));
    _this.name = "FFT";
    var options = optionsFromArguments(FFT.getDefaults(), arguments, ["size"]);
    _this.normalRange = options.normalRange;
    _this._analyser.type = "fft";
    _this.size = options.size;
    return _this;
  }
  _createClass(FFT, [{
    key: "getValue",
    /**
     * Gets the current frequency data from the connected audio source.
     * Returns the frequency data of length [[size]] as a Float32Array of decibel values.
     */
    value: function getValue() {
      var _this2 = this;
      var values = this._analyser.getValue();
      return values.map(function (v) {
        return _this2.normalRange ? dbToGain(v) : v;
      });
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by [[getValue]] (i.e. the number of
     * frequency bins). Large FFT sizes may be costly to compute.
     */
  }, {
    key: "getFrequencyOfIndex",
    /**
     * Returns the frequency value in hertz of each of the indices of the FFT's [[getValue]] response.
     * @example
     * const fft = new Tone.FFT(32);
     * console.log([0, 1, 2, 3, 4].map(index => fft.getFrequencyOfIndex(index)));
     */
    value: function getFrequencyOfIndex(index) {
      assert(0 <= index && index < this.size, "index must be greater than or equal to 0 and less than ".concat(this.size));
      return index * this.context.sampleRate / (this.size * 2);
    }
  }, {
    key: "size",
    get: function get() {
      return this._analyser.size;
    },
    set: function set(size) {
      this._analyser.size = size;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */
  }, {
    key: "smoothing",
    get: function get() {
      return this._analyser.smoothing;
    },
    set: function set(val) {
      this._analyser.smoothing = val;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        normalRange: false,
        size: 1024,
        smoothing: 0.8
      });
    }
  }]);
  return FFT;
}(MeterBase);